import './App.css';
import Home from './Home';
import Header from './Header';

function App() {
  return (
    <>
   <Header />
   <Home />
    </>
  );
}

export default App;
